import React from 'react'
import CustomerForm from '../customerForm'
import {
    CreateCustomerMutation,
    Person,
    useCreateCustomerMutation,
} from '../../../../generated/graphql'
import Loading from '../../../loading'
import { useNavigate } from 'react-router-dom'
import { addToQuery } from '../../../../apollo/resolvers'

const NewCustomer = () => {
    const navigate = useNavigate()
    const [create, { loading }] = useCreateCustomerMutation()

    const submit = React.useCallback(
        (person: Person) => {
            create({
                variables: {
                    data: {
                        name: person.name,
                        surname: person.surname,
                        email: person.email,
                        phone: person.phone,
                        address: person.address,
                        city: person.city,
                        dni: person.dni,
                        diffusion: person.customer?.diffusion,
                        wantReceiveInfo: person.customer?.wantReceiveInfo,
                        imageRights: person.customer?.imageRights,
                        contactChannel: person.customer?.contactChannel,
                        howDiscovered: person.customer?.howDiscovered,
                        documentType: person.customer?.documentType,
                        signatureDate: person.customer?.signatureDate,
                    },
                },
                onCompleted: (data: CreateCustomerMutation) => {
                    addToQuery(data.createCustomer, 'people')
                    addToQuery(data.createCustomer, 'customers')
                    navigate('/people/customers')
                },
            })
        },
        [create, navigate]
    )

    return loading ? (
        <Loading />
    ) : (
        <CustomerForm
            customer={{
                name: '',
                email: '',
                phone: '',
                dni: '',
                city: '',
                address: '',
                customer: {
                    wantReceiveInfo: undefined,
                    imageRights: undefined,
                    contactChannel: undefined,
                    howDiscovered: undefined,
                    documentType: undefined,
                    signatureDate: undefined,
                },
            }}
            submit={submit}
        />
    )
}

export default React.memo(NewCustomer)
